const ProjectName = 'CERPS';

var getAPIURL = function(){
	//return "http://localhost:8086";
	//return "http://192.168.100.6:8086";
	// return "http://192.168.50.29:8086"; 
	// return "http://13.114.173.137:8086";

  // HTTPS SERVER
	return "https://exam.cerps.org.tw/study-0.0.1-SNAPSHOT"; //更新版本號
	// return "https://13.114.173.137/study-0.0.1-SNAPSHOT";
}

const CONFIG = {

	/**

	* [API_URL]

	* @description: 全站發 api 的 endpoint

	*/
	PROJECT_NAME:ProjectName,
	API_URL: getAPIURL(),

}

export { CONFIG };
